export const GENERAL = 'core/general/'
export const COMPANY = 'core/company/'
